(function (window, $, undefined) {
 
  const VerticalScrollDirection = {
    DOWN: 0,
    UP: 1
  };

  class BottomBar {

    static gotoCompareVehicles(event) {
      if (!$(event.currentTarget).hasClass('disabled')) {
        location.href = '/vehicle-search#!/compare-vehicles';
      }
    }
  
    static gotoSavedVehicles(event) {
      if (!$(event.currentTarget).hasClass('disabled')) {
        location.href = '/saved-vehicles';
      }
    }
    
    $document = $(document);

    scrollTop = {
      current: 0,
      previous: 0,
  
      get delta() {
        return this.current - this.previous;
      }
    };

    constructor() {
      Object.assign(this, {
        content: $('<bottom-bar-content>'),
        element: $('<bottom-bar>').addClass('hide-bar'),
        onComponentShouldUpdate: this.onComponentShouldUpdate.bind(this),
        onDocumentScroll: this.onDocumentScroll.bind(this)
      });

      this.element.append(this.content);
      this.element.data('controller', this);
      this.element.insertBefore($('footer'));

      acpv.CompareVehicles.on('change', this.onComponentShouldUpdate);
      acpv.SavedVehicles.on('change', this.onComponentShouldUpdate);
  
      this.onComponentShouldUpdate();

      // reflow after angular renders (next pass of the event loop)
      setTimeout(() => this.reflow());
    }

    activateComponent() {
      this.element.css('height', `${this.content.prop('offsetHeight')}px`);
      this.reflow();

      if (this.isClosed()) {        
        this.show();
        this.$document.on('scroll', this.onDocumentScroll);
      }
    }

    deactivateComponent() {
      if (this.isOpen()) {
        this.hide();
        this.$document.off('scroll', this.onDocumentScroll);
      }

      this.element.css('height', 0);
    }

    destroy() {
      acpv.CompareVehicles.off('change', this.onComponentShouldUpdate);
      acpv.SavedVehicles.off('change', this.onComponentShouldUpdate);

      if (this.isOpen()) {
        this.$document.off('scroll', this.onDocumentScroll);
      }

      this.element.remove();
    }

    getScrollDirection() {
      this.scrollTop.previous = this.scrollTop.current;
      this.scrollTop.current = this.$document.scrollTop();

      if (this.scrollTop.delta < 0) {
        return VerticalScrollDirection.UP;
      }

      return VerticalScrollDirection.DOWN;
    }

    hasReachedElementBottom() {
      const elementClientRect = this.element[0].getBoundingClientRect();
      const contentCleintRect = this.content[0].getBoundingClientRect();

      return contentCleintRect.bottom - elementClientRect.bottom > -1;
    }

    hasReachedWindowBottom() {
      const contentClientRect = this.content[0].getBoundingClientRect();

      return window.innerHeight - contentClientRect.bottom < 1;
    }

    hide() {
      this.content.toggleClass('animate', this.isPinned());
      this.element.addClass('hide-bar').removeClass('show-bar');
    }
  
    isClosed() {
      return this.element.hasClass('hide-bar');
    }
  
    isOpen() {
      return this.element.hasClass('show-bar');
    }

    isPinned() {
      return this.content.hasClass('pin');
    }

    onComponentDidUpdate() {
      if (this.shouldComponentBecomeActive()) {
        return this.activateComponent();
      }

      return this.deactivateComponent();
    }

    onComponentShouldUpdate() {
      this.render();
      this.onComponentDidUpdate();
    }

    onDocumentScroll() {
      if (this.getScrollDirection() === VerticalScrollDirection.UP) {
        return this.onDocumentScrollUp();
      }

      return this.onDocumentScrollDown();
    }

    onDocumentScrollDown() {
      if (this.hasReachedElementBottom()) {
        this.unpin();
      }
    }

    onDocumentScrollUp() {
      if (this.hasReachedWindowBottom()) {
        this.pin();
      }
    }
    
    pin() {
      this.content.addClass('pin');
    }

    unpin() {
      this.content.removeClass('animate pin');
    }

    reflow() {
      if (this.isPinned()) {
        if (this.hasReachedElementBottom()) {
          this.unpin();
        }
      } else if (this.hasReachedWindowBottom()) {
        this.pin();
      }
    }

    shouldComponentBecomeActive() {
      return acpv.CompareVehicles.size || acpv.SavedVehicles.size;
    }
  
    show() {
      this.content.toggleClass('animate', this.isPinned());
      this.element.addClass('show-bar').removeClass('hide-bar');
    }

    renderCompareLink() {
      const {size} = acpv.CompareVehicles;
      if (size > 1){
        console.log("size: " + size)
                  return '\n        <div\n  data-tap-element-id="inventory_stickybar_compare" data-tap-compare_vehicle_count="'+size+'"  class="stickycompare clickable ' + (size < 2 && 'disabled') + '"\n          onclick="acpv.BottomBar.gotoCompareVehicles(event)">\n        \n          <div class="flex-row">\n            <div class="avenir-next-bold nav-link underline">Compare</div>\n            <div class="count avenir-next-regular" id="compareVehicleCount">\n              (' + size + ')\n            </div>\n          </div>\n        \n          <div class="avenir-next-regular help-text">View Comparison</div>\n        \n        </div>\n      ';  
                }
                else{
                  return '\n        <div\n  data-tap-element-id="inventory_stickybar_compare" data-tap-compare_vehicle_count="'+size+'"  class="stickycompare clickable ' + (size < 2 && 'disabled') + '"\n          onclick="acpv.BottomBar.gotoCompareVehicles(event)">\n        \n          <div class="flex-row">\n            <div class="avenir-next-bold nav-link">Compare</div>\n            <div class="count avenir-next-regular" id="compareVehicleCount">\n              (' + size + ')\n            </div>\n          </div>\n        \n          <div class="avenir-next-regular help-text">Select 2 to 3 vehicles</div>\n        \n        </div>\n      ';
                }             
      
    }

    renderContactDealerButton() {
      return `
        <div class="contact-dealer-btn-bottom hidden-xs">
          <a
            class="button-1-fade hidden"
            data-tracking="vehdetails_dealer_contact_open"
            id="contact-dealer-button-bottom"
            onclick="callFloodlight('contact-dealer');"
            style="cursor: pointer;">
            CONTACT DEALER
          </a>
        </div>
      `;
    }

    renderSavedLink() {
      const {size} = acpv.SavedVehicles;

      return `
        <div data-tap-element-id="inventory_stickybar_saved"
          class="stickysave clickable flex-row align-vertical-center ${size < 1 && 'disabled'}"
          onclick="acpv.BottomBar.gotoSavedVehicles(event)">
          <div class="ribbon"></div>
          <div class="avenir-next-bold nav-link ${size > 0 && 'underline'}">Saved</div>
          <div class="count avenir-next-regular" id="savedVehicleCount">(${size})</div>
        </div>
      `;
    }

    render() {
      this.content.html(`
        ${this.renderCompareLink()}
        ${this.renderContactDealerButton()}
        ${this.renderSavedLink()}
      `);
    }
  }

  window.acpv.BottomBar = BottomBar;

})(window, jQuery);
